import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloadAnimated = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "fillSlowly",
		x1: "0%",
		y1: "0%",
		x2: "0%",
		y2: "100%",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: "0%",
			stopColor: "#ffffff",
			children: /* @__PURE__ */ _jsx("animate", {
				dur: "1.5s",
				attributeName: "offset",
				fill: "freeze",
				from: 0,
				to: 1,
				repeatCount: "indefinite"
			})
		}), /* @__PURE__ */ _jsx("stop", {
			offset: "0%",
			stopColor: "#444",
			children: /* @__PURE__ */ _jsx("animate", {
				dur: "1.5s",
				attributeName: "offset",
				fill: "freeze",
				from: 0,
				to: 1,
				repeatCount: "indefinite"
			})
		})]
	}), /* @__PURE__ */ _jsx("g", {
		fill: "url(#fillSlowly)",
		children: /* @__PURE__ */ _jsx("path", { d: "M6.3077 19.5002C5.80257 19.5002 5.375 19.3252 5.025 18.9752C4.675 18.6252 4.5 18.1976 4.5 17.6925V15.0002H5.99997V17.6925C5.99997 17.7694 6.03202 17.8399 6.09612 17.904C6.16024 17.9681 6.23077 18.0002 6.3077 18.0002H17.6922C17.7692 18.0002 17.8397 17.9681 17.9038 17.904C17.9679 17.8399 18 17.7694 18 17.6925V15.0002H19.5V17.6925C19.5 18.1976 19.325 18.6252 18.975 18.9752C18.625 19.3252 18.1974 19.5002 17.6922 19.5002H6.3077ZM12 15.6155L7.7308 11.3464L8.78462 10.2618L11.25 12.7272V4.32715H12.7499V12.7272L15.2153 10.2618L16.2692 11.3464L12 15.6155Z" })
	})]
});
export default SvgDownloadAnimated;
